const faqConstants = [
  {
    id: 'landing_faq_is_it_really_free',
    question: 'Is it really free to try?',
    answer: (
      <>
        <strong>Yes.</strong>{' '}
        <span>No credit card needed. Full access during the trial.</span>
      </>
    ),
  },
  {
    id: 'landing_faq_what_levels_covered',
    question: 'What levels does it cover?',
    answer: (
      <>
        <span>
          <strong>K-8</strong>, from complete beginners to intermediate.
        </span>
      </>
    ),
  },
  {
    id: 'landing_faq_use_on_projector',
    question: 'Can I use it on a projector in class?',
    answer: (
      <>
        <strong>Yes.</strong>{' '}
        <span>
          Open it, connect the projector, and hit play. Works in seconds.
        </span>
      </>
    ),
  },
  {
    id: 'landing_faq_students_need_device',
    question: 'Do students need their own device?',
    answer: (
      <>
        <strong>No.</strong>{' '}
        <span>Works great whole-class on a single screen.</span>
      </>
    ),
  },
  {
    id: 'landing_faq_setup_time',
    question: 'How long does setup take?',
    answer: (
      <>
        <span>
          <strong>Under 2 minutes.</strong> No training needed.
        </span>
      </>
    ),
  },
];

export default faqConstants;
